import CricketCard from "../../Components/Cricket Card";
import { Helmet } from "react-helmet";

const Home = () => {
  
  return (
    <>
      <Helmet>
        <title>Live Cricket Scores & Stats | cricket betting tips</title>
        <meta
          name="description"
          content="Get the latest live cricket scores, in-depth match stats, and real-time updates only on cricket betting tips. Receive the latest updates on your favorite teams and players as the action unfolds"
        />
      </Helmet>
      <CricketCard />
    </>
  );
};

export default Home;
